const { log, formatDollars } = require("../std/index")

//
// New (Shopify) Live Price - relies on an invisible, combined dropdown to
// contain all variant permutations along with thier pre-computed prices.
//

module.exports = class LivePriceWidget {
  constructor($host, config) {
    this.config = config;

    this.dom = {
      dropdown: $('select[data-live-price-source]', $host),
      output: {
        price: $('[data-output="price"]', $host),
        prefix: $('[data-output="prefix"]', $host)
      }
    };

    this.state = {
      price: 0,
      selected: null
    };

    if (this.dom.dropdown.length) {
      this.init();
    } else {
      log("LivePriceWidget::new - no variants dropdown found. Leave price alone.");
    }
  }

  init() {
    this.prepareDropdown(this.dom.dropdown);
    this.dom.dropdown.on('change', this.onDropdownChange.bind(this));
    this.updateOutput();
  }

  onDropdownChange() {
    this.updateDataForDropdown(this.dom.dropdown);
    this.updateOutput();
  }

  updateDataForDropdown($dropdown) {
    const $option = this.dom.dropdown.find(':selected');
    if ($option.length > 0) {
      this.state.selected = $option;
      this.state.price = $option.data('price');
    } else {
      this.dom.output.price.hide();
      this.dom.output.prefix.hide();
    }
  }

  prepareDropdown($dropdown) {
    log("LivePriceWidget::prepare-dropdown -", $dropdown);
    $dropdown.children().each(function() {
      const isSoldOut = (this.textContent.indexOf("Sold Out")) > -1;
      this.dataset.oos = !isSoldOut;

      if (isSoldOut) {
        console.warn("Variant sold out - ", this.textContent);
      } else {
        // [ prefix, cost ] = this.dataset.price.split('$');
        this.dataset.price = this.dataset.price;
      }
    });

    this.updateDataForDropdown($dropdown);
  }

  updateOutput() {
    if (!this.state.selected || this.state.selected.length === 0) {
      log("LivePriceWidget::report - no option selected; skipping output update.");
      return;
    }
    log("LivePriceWidget::report - new price selected:", this.state.selected.text(), 'for', formatDollars(this.state.price));
    if (this.dom.output.price.data('oos')) {
      this.dom.output.price.text("Sold Out");
    } else {
      this.dom.output.price.text(formatDollars(this.state.price));
    }
  }
};
